import React from 'react';
import { Navigate, useLocation } from 'react-router';

interface ProtectedRouteProps {
  isAllowed: boolean; // Whether the user has the required permissions
  redirectPath?: string; // Path to redirect if access is denied
  children: React.ReactNode; // Component(s) to render if access is allowed
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  const {
    isAllowed,
    redirectPath = '/login', // Default redirect path
    children,
  } = props;

  const location = useLocation();

  if (!isAllowed) {
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
